import axios from 'axios';

export const HTTP = axios.create({
  baseURL: `https://sahabattutor.herokuapp.com/`,
  headers: {
    Authorization: localStorage.token 
  }
})